/*
 * 侧边栏「AI 填表员」名后跟的「新」红橙小标签(Figma 1936:8157)。
 *
 * 行为：
 *   - 首次进入 → 显示
 *   - 用户点击「AI 填表员」菜单项 → 隐藏 + 写 localStorage 标记
 *   - 下次进入(刷新/重开) → 读 LS 不再显示
 *
 * 接入方(SideComponent)只需要两件事：
 *   1. <AiClerkNewBadge /> 渲染在 AI 填表员菜单项文字之后
 *   2. 点击 AI 填表员菜单项的回调里调 markAiClerkBadgeSeen()
 *
 * LS key / 事件名 / 样式细节都封装在本组件内，调用方不感知。
 */
import React, { useEffect, useState } from 'react'

const STORAGE_KEY = 'today_camera_work_ai_clerk_badge_seen'
/** 同 tab 内事件桥：badge 监听后 setState 隐藏；写 LS 与状态同步用这个事件 */
const BADGE_SEEN_EVENT = 'aiClerk:badgeSeen'

/**
 * 让 AI 填表员菜单项点击时调用，写 LS 并通知 badge 隐藏。
 * 幂等：重复调用安全，多次写入同一标记 + 多次 dispatch 也无副作用。
 */
export function markAiClerkBadgeSeen(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1')
    window.dispatchEvent(new Event(BADGE_SEEN_EVENT))
  } catch {
    // localStorage 写入失败(隐私模式 / 禁用)不阻塞 — badge 当次会话不再隐藏，
    // 下次进入时读 LS 仍会显示，但接受这个降级(故障率极低)。
  }
}

const AiClerkNewBadge: React.FC = () => {
  const [seen, setSeen] = useState<boolean>(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      return false
    }
  })

  useEffect(() => {
    // 监听 markAiClerkBadgeSeen 触发的事件，让 SideComponent class 组件那边的
    // 点击事件能直接驱动本组件隐藏，不依赖 SideComponent re-render。
    const onSeen = () => setSeen(true)
    window.addEventListener(BADGE_SEEN_EVENT, onSeen)
    return () => window.removeEventListener(BADGE_SEEN_EVENT, onSeen)
  }, [])

  if (seen) return null

  // Figma 1936:8157：红橙 #ff4d2e 底，10px 白字，左下小圆角 + 其他角 8px(气泡感)。
  // className="new" 复用 styles/App.scss 在 short-menu(收起态侧边栏)下的
  // `display:none !important` 规则；视觉样式走 inline style，优先级高于 .new。
  return (
    <span
      className="new"
      style={{
        display: 'inline-block',
        marginLeft: 8,
        padding: '0 7px 1px',
        background: '#ff4d2e',
        color: '#fff',
        fontSize: 10,
        lineHeight: '13px',
        fontWeight: 500,
        borderRadius: '8px 8px 8px 2px',
        verticalAlign: 'middle'
      }}
    >
      新
    </span>
  )
}

export default AiClerkNewBadge
